import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadAllObjectives} from "../components/objective/ObjectiveActions";
import FunctionalPage from "./FunctionalPage";
import Objectives from "../components/objective/Objectives";
import {CLEAR_OBJECTIVES} from "../components/objective/actionTypes";
import {loadAllAxis} from "../components/axis/all-axis/axisAction";
import {loadAllTagCategories} from "../components/tag/tagCategory/tagCategoryAction";

const ObjectivesPage = () => {

    const dispatch = useDispatch()
    const {isLoading, objectives} = useSelector(state => state.objectives)


    useEffect(() => {
        dispatch(loadAllAxis());
        dispatch(loadAllTagCategories());
        dispatch(loadAllObjectives())
        return () => {
            dispatch({type: CLEAR_OBJECTIVES})
        }
    }, [dispatch]);

    useEffect(() => {

    }, [dispatch])

    return (
        <FunctionalPage
            title={"OKRs"}
            component={
                <Objectives
                    objectives={objectives}
                    isInteractive={true}
                    isLoading={isLoading}
                    inObjectivePage={true}
                />}
        />
    )
}


export default ObjectivesPage;